import { HttpInterceptorFn } from '@angular/common/http';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    setHeaders: { 'Access-Control-Allow-Credentials': 'true' },
    withCredentials: true,
  });
  return next(clonedRequest);
};
